import { Component, Injector, Input, OnInit } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ComponentContextService, CustomControlSchema, DataFormBase, EventData, FormSchemaBase, SameValueValidator, TextControlSchema, UserService, UserV5Service } from 'tnx-shared';

@Component({
    selector: 'lock-lich',
    templateUrl: './lock-lich.component.html',
    styleUrls: ['./lock-lich.component.scss'],
    providers: [ComponentContextService]
})
export class LockLichComponent implements OnInit {
    @Input() khoaLichItem: any;

    constructor(
        protected _injector: Injector,
        protected _userV5Service: UserV5Service,
        public _userService: UserService,
        // private _appUserService: AppUserService,
        private _recaptchaV3Service: ReCaptchaV3Service
    ) {
        // super(_injector);
    }

    ngOnInit() {
        // super.ngOnInit();

        // this.setting.baseService = this._userV5Service;

        // this.setting.schema = <FormSchemaBase[]>[
        //     new CustomControlSchema({
        //         field: 'thongBao',
        //         mdWidth: 12,
        //     }),
        // ];
    }


    async onFormInitialized(constrols: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        // if (this.model.data.id) {

        // } else {
        // }
    }

    async modifyDetailData(data) {
        data.passwordHash = '';
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }

}
